module["exports"] = ["küç.", "küçəsi", "prospekti", "pr.", "sahəsi", "sh."];